"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var handleCheckBoxClick = function handleCheckBoxClick(_ref) {
  var isDisabled = _ref.isDisabled,
    onCheck = _ref.onCheck,
    isChecked = _ref.isChecked;
  return !isDisabled && onCheck(!isChecked);
};
var CheckBox = function CheckBox(_ref2) {
  var isDisabled = _ref2.isDisabled,
    isChecked = _ref2.isChecked,
    label = _ref2.label,
    onCheck = _ref2.onCheck,
    isSmall = _ref2.isSmall,
    tooltip = _ref2.tooltip,
    backgroundColor = _ref2.backgroundColor,
    checkMarkColor = _ref2.checkMarkColor,
    uniqueID = _ref2.uniqueID;
  return _react.default.createElement("div", {
    className: "agillicCheckBoxContainer",
    "data-testid": uniqueID
  }, _react.default.createElement("button", {
    className: (0, _classnames.default)('checkBox', backgroundColor, {
      checked: isChecked,
      small: isSmall,
      disabled: isDisabled
    }),
    onClick: function onClick() {
      return handleCheckBoxClick({
        isDisabled: isDisabled,
        onCheck: onCheck,
        isChecked: isChecked
      });
    },
    disabled: isDisabled
  }, _react.default.createElement("svg", {
    viewBox: "0,0,50,50"
  }, _react.default.createElement("path", {
    d: "M5 30 L 20 45 L 45 5",
    className: "path ".concat(checkMarkColor)
  }))), _react.default.createElement("label", {
    className: "labelText ".concat(isDisabled ? 'disabled' : ''),
    title: tooltip
  }, label));
};
CheckBox.propTypes = {
  isDisabled: _propTypes.bool,
  isChecked: _propTypes.bool.isRequired,
  label: _propTypes.string,
  onCheck: _propTypes.func.isRequired,
  isSmall: _propTypes.bool,
  tooltip: _propTypes.string,
  backgroundColor: (0, _propTypes.oneOf)(['grey', 'red', 'green', 'lightGreen', 'blue', 'orange', 'darkOrange', 'purple', 'yellow']).isRequired,
  checkMarkColor: _propTypes.string,
  uniqueID: _propTypes.string
};
CheckBox.defaultProps = {
  backgroundColor: 'grey'
};
var _default = CheckBox;
exports.default = _default;